import { Suspense } from "react";
import { useRoutes, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import SettingsPage from "./components/SettingsPage";
import TicketList from "./components/TicketList";
import TicketDetail from "./components/TicketDetail";
import AgentDraftsInbox from "./components/AgentDraftsInbox";
import AgentCasesView from "./components/AgentCasesView";
import Dashboard from "./pages/Dashboard";
import Changelog from "./pages/Changelog";
import Calls from "./pages/Calls";
import Meetings from "./pages/Meetings";
import Calendar from "./pages/Calendar";
import MeetGuest from "./pages/MeetGuest";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import LicenseExpiredOverlay from "./components/LicenseExpiredOverlay";
import WarehouseShell from "./components/warehouse/WarehouseShell";
import WarehouseInbox from "./components/warehouse/WarehouseInbox";
import WarehouseTicket from "./components/warehouse/WarehouseTicket";
import routes from "tempo-routes";

function App() {
  return (
    <Suspense fallback={<p>Loading...</p>}>
      <>
        <Routes>
          {/* Authentication Routes - Only accessible when not logged in */}
          <Route path="/login" element={
            <ProtectedRoute requireAuth={false}>
              <Login />
            </ProtectedRoute>
          } />
          <Route path="/register" element={
            <ProtectedRoute requireAuth={false}>
              <Register />
            </ProtectedRoute>
          } />
          <Route path="/forgot-password" element={
            <ProtectedRoute requireAuth={false}>
              <ForgotPassword />
            </ProtectedRoute>
          } />
          {/* Video-Gast: öffentlich, Zutritt über Einladungs-PIN */}
          <Route path="/meet/:code" element={<MeetGuest />} />

          <Route path="/reset-password" element={
            <ProtectedRoute requireAuth={false}>
              <ResetPassword />
            </ProtectedRoute>
          } />

          {/* Depo (Lager) — ayrı ultra-basit mobil UI, cockpit değil */}
          <Route path="/warehouse" element={
            <ProtectedRoute requireAuth={true} allowedRoles={['warehouse', 'admin']}>
              <WarehouseShell />
            </ProtectedRoute>
          }>
            <Route index element={<WarehouseInbox />} />
            <Route path="ticket/:id" element={<WarehouseTicket />} />
          </Route>

          {/* Main layout wrapper - Protected routes */}
          <Route path="/" element={
            <ProtectedRoute requireAuth={true}>
              <AppShell />
            </ProtectedRoute>
          }>
            {/* Redirect to tickets */}
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="changelog" element={<Changelog />} />
            <Route path="neuigkeiten" element={<Navigate to="/changelog" replace />} />
            <Route path="ki-entwuerfe" element={<AgentDraftsInbox />} />
            <Route path="agent-faelle" element={<AgentCasesView />} />
            <Route path="anrufe" element={<Calls />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="kalender" element={<Calendar />} />

            {/* Tickets */}
            <Route path="tickets">
              <Route index element={<TicketList />} />
              <Route path="search" element={<TicketList currentView="search" />} />
              <Route path=":ticketId" element={<TicketDetail />} />
            </Route>

            {/* Ticket Views */}
            <Route path="tickets/new" element={<TicketList currentView="new" />} />
            <Route path="tickets/spam" element={<TicketList currentView="spam" />} />
            <Route path="tickets/unassigned" element={<TicketList currentView="unassigned" />} />
            <Route path="tickets/complaints" element={<TicketList currentView="complaints" />} />
            <Route path="tickets/returns" element={<TicketList currentView="returns" />} />
            <Route path="tickets/exchange" element={<TicketList currentView="exchange" />} />
            <Route path="tickets/billing" element={<TicketList currentView="billing" />} />
            <Route path="tickets/delivery" element={<TicketList currentView="delivery" />} />
            <Route path="tickets/mine" element={<TicketList currentView="mine" />} />
            <Route path="tickets/sla" element={<TicketList currentView="sla" />} />
            <Route path="tickets/all" element={<TicketList currentView="all" />} />
            <Route path="tickets/custom/:viewId" element={<TicketList currentView="custom" />} />

            {/* Settings - Admin only */}
            <Route path="settings">
              <Route index element={
                <ProtectedRoute allowedRoles={['admin', 'agent']}>
                  <SettingsPage />
                </ProtectedRoute>
              } />
              <Route path="users" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <SettingsPage activeSection="users" />
                </ProtectedRoute>
              } />
              <Route path="roles" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <SettingsPage activeSection="roles" />
                </ProtectedRoute>
              } />
              <Route path="snippets" element={<SettingsPage activeSection="snippets" />} />
              <Route path="shops" element={<SettingsPage activeSection="shops" />} />
              <Route path="tickets" element={<SettingsPage activeSection="tickets" />} />
              <Route path="email" element={<SettingsPage activeSection="email" />} />
              <Route path="integrations" element={<SettingsPage activeSection="integrations" />} />
              <Route path="chatbot" element={<SettingsPage activeSection="chatbot" />} />
              <Route path="notifications" element={<SettingsPage activeSection="notifications" />} />
              <Route path="general" element={<SettingsPage activeSection="general" />} />
            </Route>
          </Route>
        </Routes>
        {import.meta.env.VITE_TEMPO === "true" && useRoutes(routes)}
        <LicenseExpiredOverlay />
      </>
    </Suspense>
  );
}

export default App;
